export default __webpack_public_path__ + "static/thumbnail-319787495d091eb69d475255b2e0ab7f.jpg";